import { gql, useQuery } from "@apollo/client";
import { CashFlowOverviewQueryQuery, QueryCashFlowOverviewArgs } from "../../../../../schemaTypes";

export const cashFlowOverviewQuery = gql`
  query CashFlowOverviewQuery(
    $duration: String!
  ) {
    cashFlowOverview(
      duration: $duration 
    ) {
        totalCurrentBalance
        totalCashWithdrawn
        totalTransactionValue
    }
  }
`;

export interface WithCashFlowOverview {
  totalCurrentBalance: number;
  totalCashWithdrawn: number;
  totalTransactionValue: number;
}

interface Props {
  variables: QueryCashFlowOverviewArgs;
  children: (data: WithCashFlowOverview) => React.ReactElement | null;
}

export const CashFlowOverviewController: React.FC<Props> = ({ children, variables }) => {
  const { data } = useQuery<
    CashFlowOverviewQueryQuery,
    QueryCashFlowOverviewArgs
  >(cashFlowOverviewQuery, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  const totalCurrentBalance = data?.cashFlowOverview.totalCurrentBalance || 0;
  const totalCashWithdrawn = data?.cashFlowOverview.totalCashWithdrawn || 0;
  const totalTransactionValue = data?.cashFlowOverview.totalTransactionValue || 0;


  return children({
        totalCurrentBalance,
        totalCashWithdrawn,
        totalTransactionValue
  });
};